module.exports = __webpack_public_path__ + "51d1191ba22284d6a4d90177162cb968.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/social/speakers/abhinav-rastogi.jpg
// module id = 502
// module chunks = 0